// /frontend/src/pages/OurStoryPage.jsx
import React from 'react';
import Layout from '../components/layout/Layout';

const OurStoryPage = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">About Hale by Henderson</h1>
        <p className="text-xl text-teal-800 font-semibold mb-8">Rooted in Place, Designed for Living</p>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-lg leading-relaxed mb-6">
            At Hale by Henderson, we believe that great design begins with a sense of place. Our mission is to create timeless interiors that reflect the natural beauty, practicality, and spirit of island life.
          </p>
          
          <p className="text-lg leading-relaxed mb-6">
            Unlike traditional furniture stores, we don't sell individual pieces. Instead, we specialize in complete furniture packages — curated collections designed to transform an empty space into a home with ease and elegance.
          </p>
          
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 my-8">
            <h3 className="text-xl font-bold text-gray-900 mb-3">The Hale Foundation Collection</h3>
            <p className="text-lg leading-relaxed mb-4">
              Our newest line, the Hale Foundation Collection, was created specifically for high-rise living in Honolulu. Each package is made to order using top-grade plantation teak, available in two finish options, and includes over 110 thoughtfully designed furnishings.
            </p>
            <p className="text-lg leading-relaxed">
              From custom drawer and door panel inserts (rattan, linen, faux leather, and more) to full-service design support, every detail is considered.
            </p>
          </div>
          
          <p className="text-lg leading-relaxed mb-6">
            We make the process seamless: from floor plan layout to delivery and installation, your home is move-in ready in 4–6 months. Whether you're purchasing for yourself, staging for sale, or furnishing a model, Hale by Henderson brings elevated, island-rooted design to every project.
          </p>
          
          
          <div className="mt-12 text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-3">Ready to transform your space?</h3>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
              <a 
                href="/custom-design" 
                className="inline-block px-6 py-3 bg-teal-800 text-white rounded-lg hover:bg-teal-900 transition-colors"
              >
                Explore Design
              </a>
              <a 
                href="/designer-packages" 
                className="inline-block px-6 py-3 border-2 border-teal-800 text-teal-800 rounded-lg hover:bg-teal-50 transition-colors"
              >
                View Furniture Packages
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default OurStoryPage;